namespace GeniuzPOS.Purchase {
    export namespace PoParaService {
        export const baseUrl = 'Purchase/PoPara';

        export declare function Update(request: Serenity.SaveRequest<PoParaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Purchase/PoPara/Update",
            Retrieve = "Purchase/PoPara/Retrieve",
            List = "Purchase/PoPara/List"
        }

        [
            'Update', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoParaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
